module.exports = __webpack_public_path__ + "img/img_20years_1.57d6bcb0.jpg";